export default __webpack_public_path__ + "static/logo_alibaba-36cd85469e9ef55261f117b793542167.svg";